import { TOKEN_KEY } from "@/lib/api";

export async function downloadFile(apiPath, filename) {
  const base = `${process.env.REACT_APP_BACKEND_URL}${apiPath}`;
  const res = await fetch(base, { headers: { Authorization: `Bearer ${localStorage.getItem(TOKEN_KEY)}` } });
  if (!res.ok) throw new Error(`Download failed (${res.status})`);
  const blob = await res.blob();
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}
